<template>

    <b-modal :visible="visible" @hidden="$emit('hidden')" v-if="evt"
        :title="dialogTitle" id="eventProperties"
    @ok="saveEvent" hide-header2 :no-close-on-esc="loading" :no-close-on-backdrop="loading" size="lg">
        <div>
            <div class="loader" v-if="loading"></div>
            <b-input v-model="summary" style="width:100%" :placeholder="$t('event.summaryPlaceholder')"></b-input>
            <b-checkbox v-model="allday">{{$t('event.allday')}}</b-checkbox>
            <b-form-group :label="$t('event.time')">
                <date-time-picker :value="start" :dateOnly="allday" storeUTC
                    @input="changeStartTime"></date-time-picker>
                {{$t('event.timeSeparator')}}
                <date-time-picker v-model="end" :dateOnly="allday" storeUTC :minvalue="start"></date-time-picker>
            </b-form-group>
            <b-form-group>
            <b-checkbox v-model="recurring" :disabled="!allowEditRecurrence">{{$t('event.recurring')}}</b-checkbox>
              <b-form-group v-if="recurring">
                <b-select :disabled="!allowEditRecurrence" :options="recurOptions" v-model="recurMode"></b-select>
                <b-radio-group :disabled="!allowEditRecurrence" :options="recurEndOptions"
                    v-model="recurEnd"></b-radio-group>
                <b-form-group v-if="recurEnd === 'COUNT'" :label="$t('event.count')">
                  <b-input :disabled="!allowEditRecurrence" v-model.number="recurCount"
                      type="number" min="1" max="999"></b-input>
                </b-form-group>
                <b-form-group v-if="recurEnd === 'UNTIL'" :label="$t('event.until')">
                  <date-time-picker :disabled="!allowEditRecurrence" v-model="recurUntil" dateOnly></date-time-picker>
                </b-form-group>
              </b-form-group>
            </b-form-group>

            <b-form-group :label="$t('event.description')">
                <b-textarea v-model="description" :placeholder="$t('event.descriptionPlaceholder')"></b-textarea>
            </b-form-group>
            <b-select :options="calendars" v-model="evt.calid"></b-select>
            <!-- {{$store.state.settings['servertimezoneical']}}
            {{event}}-->
          <!--<pre>{{icalVEvent.toString()}}</pre>
          <pre>xx{{ icalBaseVEvent.toString() }}</pre>-->
        </div>
        <template v-slot:modal-footer="{ ok, cancel, hide }">
            <b-button :disabled="loading" v-if="!event.newEvent"
                @click="deleteEvent">{{$t('event.buttons.delete')}}</b-button>
            <b-button :disabled="loading" @click="cancel()">{{$t('event.buttons.cancel')}}</b-button>
            <b-button :disabled="loading" variant="primary" @click="ok()">{{$t('event.buttons.ok')}}</b-button>

        </template>
      </b-modal>

</template>

<script>
import ICAL from 'ical.js';
import DateTimePicker from '@/components/dateTimePicker';
import { DateTime, Interval } from 'luxon';
import axios from 'axios';

export default {
  name: 'calendarEvent',
  components: { DateTimePicker },
  data: function() {
    return {
      evt: {},
      jcalData: [],
      icalComponent: {},
      icalVEvent: {},
      icalEvent: {},
      icalBaseVEvent: {},
      icalBsaEvent: {},
      key: 0,
      loading: false
    };
  },
  props: {
    event: Object,
    visible: Boolean
  },
  watch: {
    event(newVal) {
      this.load(this.event);
    }
  },
  mounted() {
    this.load(this.event);
  },
  methods: {
    load(evt) {
      if (this.event) {
        console.log('load', this.event);
        this.evt = Object.assign({}, this.event);
        this.jcalData = ICAL.parse(this.evt.raw);
        console.log('load 1a');

        // console.log(this.jcalData);
        console.log('load 2a');

        console.log(ICAL.stringify(this.jcalData));
        console.log('load 2');

        this.icalComponent = new ICAL.Component(this.jcalData);
        if (this.$route.name === 'calendarEvent') {
          this.icalVEvent = this.icalComponent.getFirstSubcomponent('vevent');
          this.icalBaseVEvent = this.icalVEvent;
        } else if (this.$route.name === 'calendarRecurEventSingle') {
          const evts = this.icalComponent.getAllSubcomponents('vevent');
          const thisRecurId = this.evt.recurId + 'Z';
          console.log('recur events', evts);
          this.icalVEvent = evts.find(e => {
            const id = e.getFirstPropertyValue('recurrence-id');
            if (id) {
              console.log(id.toICALString(), this.evt.recurId, id.toICALString() === thisRecurId);
              return id.toICALString() === thisRecurId;
            }
            return false;
          });
          if (!this.icalVEvent) {
            this.icalVEvent = this.makeSingleOccurrenceEvent(this.evt.recurId);
            this.icalComponent.addSubcomponent(this.icalVEvent);
          }
          this.icalBaseVEvent = this.icalComponent.getFirstSubcomponent('vevent');
          console.log('found', this.icalVEvent);
        } else {
          console.log('route', this.$route.name);
          return;
        }

        this.icalEvent = new ICAL.Event(this.icalVEvent);
        this.icalBaseEvent = new ICAL.Event(this.icalBaseVEvent);
        console.log('load 3');
        console.log(this.icalEvent);
        console.log(this.icalComponent.toString());
        console.log('load 5');
        const tz = this.icalComponent.getFirstSubcomponent('vtimezone');
        if (tz) {
          ICAL.TimezoneService.register(tz);
        }
        this.key++;
        this.loading = false;
      } else {
        this.key = 0;
      }
    },
    makeSingleOccurrenceEvent(recurId) {
      const base = this.icalComponent.getFirstSubcomponent('vevent').toString();
      let icalVEvent = ICAL.Component.fromString(base);
      icalVEvent.removeAllProperties('rrule');
      icalVEvent.removeAllProperties('rdate');
      icalVEvent.removeAllProperties('exdate');
      icalVEvent.addPropertyWithValue('recurrence-id', this.iCalToISO(recurId + 'Z'));
      icalVEvent.updatePropertyWithValue('dtstart',
        ICAL.Time.fromDateTimeString(this.evt.start, icalVEvent.getFirstProperty('dtstart')));
      return icalVEvent;
    },
    changeStartTime(val) {
      if (this.icalVEvent.hasProperty('dtend')) {
        const oldVal = DateTime.fromISO(this.start);
        let end = DateTime.fromISO(this.end);
        const newVal = DateTime.fromISO(val);
        const duration = Interval.fromDateTimes(oldVal, end).toDuration();
        end = newVal.plus(duration);
        this.end = end.toUTC().toISO({ suppressMilliseconds: true });
      }
      this.start = val;
    },
    iCalToISO(time) {
      return `${time.substr(0, 4)}-${time.substr(4, 2)}-${time.substr(6, 2)}T` +
          `${time.substr(9, 2)}:${time.substr(11, 2)}:${time.substr(13, 2)}Z`;
    },
    deleteEvent(e) {
      if (this.$route.name === 'calendarRecurEventSingle') {
        this.deleteSingleEvent(e);
      } else if (this.$route.name === 'calendarRecurEventFuture') {
        this.deleteThisAndFutureEvents(e);
      } else if (this.$route.name === 'calendarEvent') {
        this.loading = true;

        axios.delete(`rest/user/calendars/${this.evt.calid}/${this.event.id}`)
          .then(() => {
            this.loading = false;
            this.$nextTick(() => {
              this.$emit('deleteEvent', { event: this.evt });
            });
          })
          .catch(e => {
            console.log(e);
            this.$dialog.alert(this.$t('eventDeleteFailed', { error: e.message }));
            this.loading = false;
          });
      }
    },
    deleteSingleEvent(e) {
      let exDates = this.icalVEvent.getFirstProperty('exdate');
      if (!exDates) {
        exDates = new ICAL.Property('exdate');
        exDates.setValue(this.iCalToISO(this.evt.recurId));
        this.icalVEvent.addProperty(exDates);
        console.log('date', exDates);
      } else {
        let dates = exDates.getValues();
        dates.push(this.iCalToISO(this.evt.recurId));
        exDates.setValues(dates);
      }
      this.saveEvent(e);
    },
    deleteThisAndFutureEvents(e) {
      const recur = this.icalVEvent.getFirstPropertyValue('rrule');
      recur.until = ICAL.Time.fromDateTimeString(this.iCalToISO(this.evt.recurId)).adjust(0, 0, 0, -1);
      recur.count = null;
      this.icalVEvent.updatePropertyWithValue('rrule', recur);
      alert(this.icalVEvent.toString());
      this.saveEvent(e);
    },
    saveEvent(e) {
      e.preventDefault();
      this.loading = true;
      if (this.event.newEvent) {
        axios.post(`rest/user/calendars/${this.evt.calid}`, {
          ical: this.icalComponent.toString() })
          .then(d => {
            console.log(d);
            this.loading = false;
            this.$nextTick(() => {
              this.$emit('save', { origCalId: this.event.calid, event: this.evt });
              this.$bvModal.hide('eventProperties');
            });
          })
          .catch(e => {
            console.log(e);
            this.$dialog.alert(this.$t('eventSaveFailed', { error: e.message }));
            this.loading = false;
          });
      } else {
        if (this.$route.name === 'calendarRecurEventFuture') {
          this.deleteThisAndFutureEvents(e);
        }
        console.log('save Component', this.icalComponent.toString());

        axios.put(`rest/user/calendars/${this.event.calid}/${this.event.id}`, {
          calid: this.evt.calid,
          ical: this.icalComponent.toString()
        })
          .then(d => {
            console.log(d);
            this.loading = false;
            this.$nextTick(() => {
              this.$emit('save', { origCalId: this.event.calid, event: this.evt });
              this.$bvModal.hide('eventProperties');
            });
          })
          .catch(e => {
            console.log(e);
            this.$dialog.alert(this.$t('eventSaveFailed', { error: e.message }));
            this.loading = false;
          });
      }
    }
  },
  computed: {
    calendars() {
      return this.$store.getters.calendarDisplayList(this).map(c => {
        return { text: c.dispName, value: c.id };
      });
    },
    allowEditRecurrence() {
      return this.$route.name === 'calendarEvent';
    },
    dialogTitle() {
      return this.$t('event.title', { summary: this.summary });
    },
    start: {
      get() {
        if (this.key > 0) {
          return this.icalEvent.startDate.toString();
        }
        return '';
      },
      set(val) {
        if (this.allday) {
          this.icalEvent.startDate = ICAL.Time.fromDateString(val);
        } else {
          this.icalEvent.startDate = ICAL.Time.fromDateTimeString(val, this.icalVEvent.getFirstProperty('dtstart'));
        }
        this.key++;
      }
    },
    end: {
      get() {
        if (this.key > 0) {
          if (this.allday) {
            return DateTime.fromISO(this.icalEvent.endDate).minus({ seconds: 1 }).toISO({ suppressMilliseconds: true });
          } else {
            return this.icalEvent.endDate.toString();
          }
        }
        return '';
      },
      set(val) {
        if (this.allday) {
          val = DateTime.fromISO(val).startOf('day').plus({ days: 1 }).toISO({ suppressMilliseconds: true });
          this.icalEvent.endDate = ICAL.Time.fromDateString(val);
        } else {
          this.icalEvent.endDate = ICAL.Time.fromDateTimeString(val, this.icalVEvent.getFirstProperty('dtend'));
        }
        this.key++;
      }
    },
    description: {
      get() {
        if (this.key > 0) {
          return this.icalEvent.description;
        }
        return '';
      },
      set(val) {
        this.icalEvent.description = val;
        this.key++;
      }
    },
    summary: {
      get() {
        if (this.key > 0) {
          return this.icalEvent.summary;
        }
        return '';
      },
      set(val) {
        this.icalEvent.summary = val;
        this.key++;
      }
    },
    location: {
      get() {
        if (this.key > 0) {
          return this.icalEvent.location;
        }
        return '';
      },
      set(val) {
        this.icalEvent.location = val;
        this.key++;
      }
    },
    allday: {
      get() {
        if (this.key > 0) {
          return this.icalEvent.startDate.isDate;
        }
        return false;
      },
      set(val) {
        if (val) {
          this.icalEvent.startDate = ICAL.Time.fromDateString(this.icalEvent.startDate.toString());
          this.icalEvent.endDate = ICAL.Time.fromDateString(this.icalEvent.endDate.toString());
        } else {
          this.icalEvent.startDate = ICAL.Time.fromDateTimeString(`${this.icalEvent.startDate.toString()}T12:00:00`);
          this.icalEvent.endDate = ICAL.Time.fromDateTimeString(`${this.icalEvent.endDate.toString()}T13:00:00`);
        }
        this.key++;
      }
    },
    recurring: {
      get() {
        if (this.key > 0) {
          return this.icalBaseEvent.isRecurring();
        } else {
          return false;
        }
      },
      set(val) {
        if (val) {
          const recur = ICAL.Recur.fromData({ freq: 'WEEKLY' });
          this.icalVEvent.updatePropertyWithValue('rrule', recur);
        } else {
          this.icalVEvent.removeAllProperties('rrule');
          this.icalVEvent.removeAllProperties('rdate');
          this.icalVEvent.removeAllProperties('exdate');
        }
      }
    },
    recurOptions() {
      return [
        { text: this.$t('event.recur.daily'), value: 'DAILY' },
        { text: this.$t('event.recur.weekly'), value: 'WEEKLY' },
        { text: this.$t('event.recur.weekdays'), value: 'WEEKDAYS' },
        { text: this.$t('event.recur.biweekly'), value: 'BIWEEKLY' },
        { text: this.$t('event.recur.monthly'), value: 'MONTHLY' },
        { text: this.$t('event.recur.yearly'), value: 'YEARLY' },
        { text: this.$t('event.recur.custom'), value: 'CUSTOM' }
      ];
    },
    recurMode: {
      get() {
        if (this.key > 0) {
          const recur = this.icalBaseVEvent.getFirstPropertyValue('rrule');

          if ((recur.getComponent('bysecond').length > 0) ||
              (recur.getComponent('byminute').length > 0) ||
              (recur.getComponent('byhour').length > 0) ||
              (recur.getComponent('bymonthday').length > 0) ||
              (recur.getComponent('byyearday').length > 0) ||
              (recur.getComponent('byweekno').length > 0) ||
              (recur.getComponent('bymonth').length > 0) ||
              (recur.getComponent('bysetpos').length > 0)) {
            return 'CUSTOM';
          }

          const interval = recur.interval;
          const freq = recur.freq;

          const byDay = recur.getComponent('byday');
          if (byDay.length === 5) {
            if ((byDay.indexOf('MO') !== -1) &&
                (byDay.indexOf('TU') !== -1) &&
                (byDay.indexOf('WE') !== -1) &&
                (byDay.indexOf('TH') !== -1) &&
                (byDay.indexOf('FR') !== -1) &&
                (interval === 1) &&
                ((freq === 'DAILY') || (freq === 'WEEKLY'))) {
              return 'WEEKDAYS';
            }
            return 'CUSTOM';
          } else if (byDay.length > 0) {
            return 'CUSTOM';
          }

          if (interval === 1) {
            if (freq === 'DAILY') {
              return 'DAILY';
            } else if (freq === 'WEEKLY') {
              return 'WEEKLY';
            } else if (freq === 'MONTHLY') {
              return 'MONTHLY';
            } else if (freq === 'YEARLY') {
              return 'YEARLY';
            }
          } else if (interval === 2) {
            if (freq === 'WEEKLY') {
              return 'BIWEEKLY';
            }
          }
        }
        return 'CUSTOM';
      },
      set(val) {
        let recur;
        this.recurring = false;
        switch (val) {
          case 'DAILY':
            recur = new ICAL.Recur({ 'freq': 'DAILY' });
            break;

          case 'WEEKLY':
            recur = new ICAL.Recur({ 'freq': 'WEEKLY' });
            break;

          case 'WEEKDAYS':
            recur = new ICAL.Recur({ 'freq': 'DAILY', 'byday': ['MO', 'TU', 'WE', 'TH', 'FR'] });
            break;

          case 'BIWEEKLY':
            recur = new ICAL.Recur({ 'freq': 'WEEKLY', interval: 2 });
            break;

          case 'MONTHLY':
            recur = new ICAL.Recur({ 'freq': 'MONTHLY' });
            break;

          case 'YEARLY':
            recur = new ICAL.Recur({ 'freq': 'YEARLY' });
            break;
        }

        if (recur) {
          this.icalVEvent.updatePropertyWithValue('rrule', recur);
          this.key++;
        }
      }
    },
    recurEndOptions() {
      return [
        { text: this.$t('event.recur.forever'), value: 'FOREVER' },
        { text: this.$t('event.recur.count'), value: 'COUNT' },
        { text: this.$t('event.recur.until'), value: 'UNTIL' }
      ];
    },
    recurEnd: {
      get() {
        if (this.key > 0) {
          const recur = this.icalBaseVEvent.getFirstPropertyValue('rrule');
          if (recur.isByCount()) {
            return 'COUNT';
          } else if (recur.isFinite()) {
            return 'UNTIL';
          } else {
            return 'FOREVER';
          }
        } else {
          return 'FOREVER';
        }
      },
      set(val) {
        const recur = this.icalVEvent.getFirstPropertyValue('rrule');
        console.log('setEnd', val);

        switch (val) {
          case 'FOREVER':
            recur.until = null;
            recur.count = null;
            break;
          case 'COUNT':
            recur.count = 10;
            recur.until = null;
            break;
          case 'UNTIL':
            {
              const Until = DateTime.utc().plus({ years: 1 });
              recur.until = ICAL.Time.fromJSDate(Until.toJSDate());
              recur.count = null;
            }
            break;
        }
        // this.recurring = false;

        this.icalVEvent.updatePropertyWithValue('rrule', recur);
        this.key++;
      }
    },
    recurCount: {
      get() {
        if (this.key > 0) {
          const recur = this.icalBaseVEvent.getFirstPropertyValue('rrule');
          return recur.count;
        }
        return 0;
      },
      set(val) {
        if ((val > 0) && (val <= 999)) {
          const recur = this.icalVEvent.getFirstPropertyValue('rrule');
          recur.count = val;
          // this.recurring = false;
          this.icalVEvent.updatePropertyWithValue('rrule', recur);
        }
        this.key++;
      }
    },
    recurUntil: {
      get() {
        if (this.key > 0) {
          const recur = this.icalBaseVEvent.getFirstPropertyValue('rrule');
          return recur.until.toString();
        }
        return '';
      },
      set(val) {
        const recur = this.icalVEvent.getFirstPropertyValue('rrule');
        const Until = DateTime.fromISO(val + 'T23:59:59');
        recur.until = ICAL.Time.fromJSDate(Until.toJSDate(), true);
        // this.recurring = false;
        this.icalVEvent.updatePropertyWithValue('rrule', recur);
        this.key++;
      }
    }
  }
};
</script>

<style scoped lang="scss">

    .loader {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: transparent;
        z-index: 100;
    }

</style>
